import { Expertise, StylingPreference } from '../types/stylist';

export const CREATE_ACCOUNT_STEP = 0;
export const ADD_PAYMENT_STEP = 1;
export const SELECT_PREFERENCES_STEP = 2;
export const ABOUT_YOU_STEP = 3;
export const FINISHED_STEP = 4;

export const clientOnboardingTitleTextOptions: { [key: number]: string } = {
  [CREATE_ACCOUNT_STEP]: 'CREATE YOUR ACCOUNT',
  [ADD_PAYMENT_STEP]: '',
  [SELECT_PREFERENCES_STEP]: 'DEFINE YOUR STYLE',
  [ABOUT_YOU_STEP]: 'ABOUT YOU',
  [FINISHED_STEP]: 'READY TO GET STYLED?',
};

export const clientOnboardingDescriptionTextOptions: { [key: number]: string } =
  {
    [CREATE_ACCOUNT_STEP]:
      'Upload a clear photo and enter your full name—this helps stylists get to know you and tailor their advice just for you.',
    [ADD_PAYMENT_STEP]: '',
    [SELECT_PREFERENCES_STEP]:
      "Find the aesthetic that speaks to you. Select as many as you like—because great style doesn't fit in a box.",
    [ABOUT_YOU_STEP]:
      'Optionally add additional details to help your stylist recommend the best options for you.',
    [FINISHED_STEP]:
      'Find your match, book a call, and meet your best-dressed self.',
  };

export const selectButtonDescriptions: Record<
  Expertise | StylingPreference,
  string
> = {
  [Expertise.BIG_TALL]: '',
  [Expertise.BLACK_TIE]: '',
  [Expertise.BRIDAL]: '',
  [Expertise.BUSINESS_TRAVEL]: '',
  [Expertise.CAPSULE_WARDROBE]: '',
  [Expertise.CARRY_ON]: '',
  [Expertise.CLOSET_EDIT]: '',
  [Expertise.DATE_NIGHT]: '',
  [Expertise.DESTINATION]: '',
  [Expertise.EDITORIAL]: '',
  [Expertise.EVERYDAY]: '',
  [Expertise.MATERNITY]: '',
  [Expertise.MODEST]: '',
  [Expertise.PETITE]: '',
  [Expertise.PLUS_SIZE]: '',
  [Expertise.SPORT]: '',
  [Expertise.STREET_STYLE]: '',
  [Expertise.TV_FILM_MEDIA]: '',
  [Expertise.VACATION]: '',
  [Expertise.VINTAGE]: '',
  [Expertise.WORK_OUTFITS]: '',
  [Expertise.WEDDING_GUEST]: '',
  [StylingPreference.BOHEMIAN]:
    'Flowy fabrics, layered, and effortlessly cool.',
  [StylingPreference.FEMININE]:
    'Soft pastels, floral prints, and ultra-feminine silhouettes.',
  [StylingPreference.GRUNGE]:
    'Leather jackets, ripped denim, oversized flannels, band tees, and an effortlessly messy vibe',
  [StylingPreference.MAXIMALIST]:
    'Bold prints, vibrant colors, layers upon layers—your outfits are a walking mood board of personal expression',
  [StylingPreference.MINIMALIST]:
    'Clean lines, muted tones, and an emphasis on quality over quantity.',
  [StylingPreference.CLASSIC]:
    'Tailored blazers, crisp button-downs, and neutral palettes.',
  [StylingPreference.TRENDY]:
    'You embrace the latest trends and runway-inspired moments.',
  [StylingPreference.STREETWEAR]:
    'Interesting silhouettes, sneakers that double as collectibles, and a mix of high and low.',
  [StylingPreference.ATHLEISURE]:
    "Elevated workout wear and an “on-the-go” aesthetic that doesn't compromise style.",
  [StylingPreference.VINTAGE]:
    'You know the thrill of a good vintage score—mixing eras, reworking silhouettes, making old-school trends feel undeniably now.',
};
